<template>
    <v-app>

      <TileSimple :values="values">

         <template v-slot:title>
            <h5>{{ $tc('texts.accounts', accounts.count, { count: accounts.count }) }} {{ $t('titles.tile_smtppro') }}</h5>
         </template>

         <template v-slot:header>
            <h4>{{ values.value }} {{ values.unit }}</h4>
         </template>

         <template v-slot:dropdown>
            <b-dropdown dropdown class="float-right" variant="transparent p-0" right>
               <template slot="button-content">
                  <i class="icon-settings"></i>
               </template>
               <b-dropdown-item href="/#/platform/servicesmtppro">{{ $t('titles.smtppro_details') }}</b-dropdown-item>
               <b-dropdown-divider></b-dropdown-divider>
               <b-dropdown-item @click="switch_type('month','mails')">{{ $t('texts.smtppro_mails_month') }}</b-dropdown-item>
               <b-dropdown-item @click="switch_type('month_cum','mails')">{{ $t('texts.smtppro_mails_month_cumulative') }}</b-dropdown-item>
               <b-dropdown-item @click="switch_type('last30','mails')">{{ $t('texts.smtppro_mails_last30') }}</b-dropdown-item>
               <b-dropdown-item @click="switch_type('last12months','mails')">{{ $t('texts.smtppro_mails_last12months') }}</b-dropdown-item>
               <b-dropdown-item @click="switch_type('month','bytes')">{{ $t('texts.smtppro_bytes_month') }}</b-dropdown-item>
               <b-dropdown-item @click="switch_type('month_cum','bytes')">{{ $t('texts.smtppro_bytes_month_cumulative') }}</b-dropdown-item>
               <b-dropdown-item @click="switch_type('last30','bytes')">{{ $t('texts.smtppro_bytes_last30') }}</b-dropdown-item>
               <b-dropdown-item @click="switch_type('last12months','bytes')">{{ $t('texts.smtppro_bytes_last12months') }}</b-dropdown-item>
            </b-dropdown>
         </template>

         <template v-slot:message>
            <p>{{ values.message }}</p>
         </template>

         <template v-slot:graph>
            <ddoGraphBar v-if="loaded" ref="myGraphLine" :chartdata="chartdata" :options="options" :height="height"/>
         </template>

      </TileSimple>

    </v-app>

</template>

<script>
import i18n from '@/plugins/i18n.js';
import util from 'util';
import TileSimple from '@/components/partials/TileSimple.vue';
import ddoGraphBar from '@/components/ddoGraphBar.vue';
import ddoSelect2 from '@/components/ddoSelect2.vue';
import ddoAlert from '@/components/ddoAlert.vue';

export default {
   name: 'TileSimpleSMTPPRO',
   components: {
      TileSimple,
      ddoGraphBar,
      ddoSelect2,
      ddoAlert,
   },

   data: function () {
      return {

         locale: null,
         accounts : {
            count: null,
            rows: [],
            current_type: null,
            current_data: null,
            current_account: 'null',
            per_status: false,
         },

         ws_code: 'service',
         ws_key: 'SMTP-PRO-SERVICE',
         ws_stats_keyword: 'stats',
         ws_search_code: 'service_smtppro',
         ws_search_keyword: 'search',
         ws_report_type: 'month',

         loading: false,
         searching: false,
         loaded: false,
         chartdata: null,
         options: null,
         ZOOMoptions: null,
         height: 250,
         data_type: 'mails',
         rows: [],
         bgcolors: [],
         showFullGraph: false,
         showSearchDialog: false,
         showMessageDetail: false,
         current_messageid: null,

         dropdown_graph_text: i18n.t('texts.choose_dropdown_graph'),
         dropdown_graph_account: i18n.t('texts.choose_dropdown_account'),

         search_errors: [],
         message_errors: [],

         values : {
            value: null,
            total_messages: null,
            total_bytes: null,
            message : null,
            labels: [],
            date: [],
            severity: [],
            data: [],
            data1: [],
            data2: [],
         } 
      }
   },

   computed: {
      datesFormatted () {
         if ( Array.isArray(this.dates) ) {
            if ( this.dates.length==2 && this.dates[0]>this.dates[1] ) {
               let tmp = this.dates[0];
               this.dates[0] = this.dates[1];
               this.dates[1] = tmp;
            }
            return this.dates.join(' ~ ')
         } else {
            return this.dates
         }
      },
      isFormValid: {
         get: function() {
            console.log('isFormValid, get, value='+this.boolFormValid);
            return this.boolFormValid;
         },
         set: function(newValue) {
            console.log('isFormValid, set, newValue='+newValue);
            this.boolFormValid = newValue;
         }
      },
   },

   async mounted() {
      var style = getComputedStyle(document.body);
      this.bgcolors[0] = style.getPropertyValue('--success');
      this.bgcolors[1] = style.getPropertyValue('--warning');
      this.bgcolors[2] = style.getPropertyValue('--danger');

      await this.refresh_data();
      this.switch_type('month_cum','mails');

      this.locale = navigator.language;

      this.accounts.current_type = this.ws_report_type;
      this.accounts.current_data = this.data_type;
    },

   methods : {

      async switch_type(report_type,data_type,account_name='null') {
         this.data_type = data_type;
         this.ws_report_type = report_type;

         this.accounts.current_type    = report_type;
         this.accounts.current_account = account_name;
         this.accounts.current_data    = data_type;
         
         await this.refresh_data();
      },

      async refresh_data(force_all=false) {
         var type = this.ws_report_type;
         if ( this.ws_report_type=='month_cum' ) { type = 'month'; }
         var parameters = { plf_report_type: type, plf_report_account: this.accounts.current_account, plf_per_status: this.accounts.per_status };
         this.loaded = false;

         let { errorinfos, api_response } = await this.$api.getRows( this.$router, this.ws_code+'/'+this.ws_key+'/'+this.ws_stats_keyword, parameters );

         if ( force_all==true ) {
            this.accounts.count = null;
            this.accounts.rows = [];
            this.accounts.current_account = 'null';
         }

         if ( api_response.error==0 ) {
            this.restructure_data(api_response.rows);
            this.loaded = true;
         }
      },

      get_max(data,_min=0) {
         var _max = _min;
         for( var i=0;i<data.length;i++ ) {
            if ( data[i]>_max ) { _max = data[i]; }
         }
         return _max;
      },

      compute_currentmonth(data) {
         if (data[0] && data[0].prl_day) {
            var _date = new Date(data[0].prl_day);
         } else {
            var _date = new Date(data[0].prl_day);
         }
         var _month = _date.getMonth();
         return _month;
      },

      build_labels(report_type,data,length) {
         var labels = [];
         var _format = 'short';
         if ( report_type=='last12months' ) {
            _format = 'monthly';
         }
         for (var i=0;i<data.length;i++) {
            labels.push( this.$api._d(data[i],_format) );
         }
         if ( labels.length<length && ( report_type=='month' || report_type=='month_cum' ) ) {
            for (var i=labels.length;i<length;i++) {
               labels.push( '' );
            }
         }
         return labels;
      },

      build_bgcolors(report_type,data,length) {
         var bgcolors = [];
         for (var i=0;i<data.length;i++) {
            bgcolors.push( this.bgcolors[data[i]] );
         }
         if ( bgcolors.length<length && ( report_type=='month' || report_type=='month_cum' ) ) {
            for (var i=bgcolors.length;i<length;i++) {
               bgcolors.push( '' );
            }
         }
         return bgcolors;
      },

      build_options(report_type,data) {
         var options = {
            legend: {
               display: false,
            },
            scales: {
               xAxes: [ {
                  display: false,
               }],
               yAxes: [ {
                  display: false,
                  ticks: {
                     min: 0,
                     max: this.get_max(data),
                  }
               }]
            }
         };
         return options;
      },

      prepare_chart_data(values) {
         var dataset_label = '';
         switch ( this.data_type ) {

            case 'mails':
               values.value = values.total_messages;
               values.unit = i18n.t('texts._emails').toLowerCase();
               switch( this.ws_report_type ) {
                  case 'month'        : values.message = i18n.t('texts.smtppro_mails_month_short'); break;
                  case 'month_cum'    : values.message = i18n.t('texts.smtppro_mails_month_cumulative_short'); break;
                  case 'last30'       : values.message = i18n.t('texts.smtppro_mails_last30_short'); break;
                  case 'last12months' : values.message = i18n.t('texts.smtppro_mails_last12months_short'); break;
               }
               if ( this.ws_report_type=='month_cum' ) {
                  values.data = values.data1cum;
               } else {
                  values.data = values.data1;
               }
               dataset_label = i18n.t('headers.messages');
               break;

            case 'bytes':
               values.value = parseInt(this.$api._format_bytes(values.total_bytes,'mega',false));
               values.unit = i18n.t('utils.megabytes');
               switch( this.ws_report_type ) {
                  case 'month'        : values.message = i18n.t('texts.smtppro_bytes_month_short'); break;
                  case 'month_cum'    : values.message = i18n.t('texts.smtppro_bytes_month_cumulative_short'); break;
                  case 'last30'       : values.message = i18n.t('texts.smtppro_bytes_last30_short'); break;
                  case 'last12months' : values.message = i18n.t('texts.smtppro_bytes_last12months_short'); break;
               }

               if ( this.ws_report_type=='month_cum' ) {
                  values.data = values.data2cum;
               } else {
                  values.data = values.data2;
               }
               dataset_label = i18n.t('headers.megabytes');
               break;
         }

         if ( this.accounts.current_account && this.accounts.current_account!='null' ) {
            dataset_label  = dataset_label + ' (' + this.accounts.current_account + ')';
         }

         var _nb_of_rows = 31;
         if ( this.ws_report_type=='last12months') {
            _nb_of_rows = 12;
         }
         this.chartdata = {
            labels : this.build_labels(this.ws_report_type,values.date,_nb_of_rows),
            datasets: [
               {
                  label: dataset_label,
                  backgroundColor: this.build_bgcolors('month',values.severity,_nb_of_rows),
                  data: values.data
               },
            ]
         };
         this.options = this.build_options('month',values.data);
         this.values = values;
      },

      restructure_data(rows) {
         var values = { value: 0, unit: '', total_bytes: 0, total_messages: 0, message: '', labels: [], severity: [], date: [], data1: [], data2: [], data1cum: [], data2cum: [], data: [], reference: [] }
         var value2cum = 0;

         for ( var i=0; i<rows.length; i++ ) {

            // If first row, and first time (count==null), we analyze and store number of accounts, and list of accounts
            if ( i==0 && this.accounts.count==null ) {
               this.accounts.count = rows[i].account_count;
               let accountrows = rows[i].account_list.split(',');
               if ( this.accounts.count>1 ) {
                  this.accounts.rows.push( { _pk: -1, code: 'null', name: '*' } );
               }
               for (var j=0;j<accountrows.length;j++) {
                  this.accounts.rows.push( { _pk: j, code: accountrows[j], name: accountrows[j] } );
               }
            }

            values.total_messages = values.total_messages+parseInt(rows[i].prl_count1);
            values.total_bytes = values.total_bytes+parseInt(rows[i].prl_count2);
            values.date.push(rows[i].prl_day);
            values.severity.push(rows[i].esv_severity);

            values.data1.push(parseInt(rows[i].prl_count1));
            if ( i>0 ) {
               values.data1cum.push(parseInt(rows[i].prl_count1)+values.data1cum[i-1]);
            } else {
               values.data1cum.push(parseInt(rows[i].prl_count1));
            }

            values.data2.push( Math.round( this.$api._format_bytes(rows[i].prl_count2,'mega')) );
            if ( i>0 ) {
               value2cum += parseInt(rows[i].prl_count2);
               values.data2cum.push( Math.round( this.$api._format_bytes(value2cum,'mega')) );
            } else {
               value2cum = parseInt(rows[i].prl_count2);
               values.data2cum.push( Math.round( this.$api._format_bytes(value2cum,'mega')) );
            }
         }
         this.prepare_chart_data(values);
      },

   }

}
</script>

<style>
.mark, mark {
    padding: .2em;
    background-color: yellow;
}
</style>